import { Users } from '@platform/client';
import { ReactElement, ReactNode } from 'react';
import { Button } from '@platform/components';

const ConnectIcon = () => {
  return (
    <svg width='81' height='80' viewBox='0 0 81 80' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_3_15196)'>
        <path
          d='M40.5 80C62.5914 80 80.5 62.0914 80.5 40C80.5 17.9086 62.5914 0 40.5 0C18.4086 0 0.5 17.9086 0.5 40C0.5 62.0914 18.4086 80 40.5 80Z'
          fill='#0E14A3'
        />
        <path
          d='M80.5001 40C80.5001 38.4059 80.404 36.8345 80.2226 35.2889L68.1719 22.845L52.9124 22.862L48.0797 33.1597L41.5327 26.3973L26.6802 26.128L25.0288 35.8319L48.5894 59.423L47.8635 60.1281L29.866 42.1306L15.3949 56.1923L39.1783 79.9758C39.6174 79.99 40.0576 79.9997 40.5001 79.9997C62.5913 80 80.5001 62.0913 80.5001 40Z'
          fill='#3339CC'
        />
        <path
          d='M46.4995 14.1562H22.3794C21.2297 14.1562 20.298 15.0883 20.298 16.2377V28.2366C20.298 29.3863 21.23 30.318 22.3794 30.318H24.3384V34.8806C24.3384 35.7722 25.4164 36.2188 26.0467 35.5883L31.3173 30.3177H46.4995C47.6492 30.3177 48.5809 29.3856 48.5809 28.2363V16.2375C48.5808 15.088 47.6488 14.1562 46.4995 14.1562Z'
          fill='#C5DBFF'
        />
        <path
          d='M46.4995 14.1562H34.4844V30.3178H46.4995C47.6492 30.3178 48.5809 29.3858 48.5809 28.2364V16.2375C48.5808 15.088 47.6488 14.1562 46.4995 14.1562Z'
          fill='#C5DBFF'
        />
        <path d='M44.5404 18.9872H24.3384V20.4566H44.5404V18.9872Z' fill='#366695' />
        <path d='M44.5404 23.0276H24.3384V24.497H44.5404V23.0276Z' fill='#366695' />
        <path
          d='M42.5814 22.237H66.7016C67.8512 22.237 68.783 23.1691 68.783 24.3184V36.3173C68.783 37.467 67.8509 38.3987 66.7016 38.3987H64.7425V42.9614C64.7425 43.853 63.6645 44.2995 63.0342 43.6691L57.7636 38.3984H42.5814C41.4317 38.3984 40.5 37.4664 40.5 36.317V24.3184C40.5 23.1687 41.432 22.237 42.5814 22.237Z'
          fill='#FEE187'
        />
        <path
          d='M66.7014 22.237H52.8008V38.3986H57.7634L63.0341 43.6692C63.6647 44.2995 64.7423 43.8531 64.7423 42.9616V38.3989H66.7014C67.8511 38.3989 68.7828 37.4669 68.7828 36.3175V24.3183C68.7828 23.1687 67.8508 22.237 66.7014 22.237Z'
          fill='#FFC61B'
        />
        <path
          d='M22.3181 58.9414C27.8967 58.9414 32.419 54.4191 32.419 48.8405C32.419 43.2619 27.8967 38.7395 22.3181 38.7395C16.7395 38.7395 12.2172 43.2619 12.2172 48.8405C12.2172 54.4191 16.7395 58.9414 22.3181 58.9414Z'
          fill='#FFEDB5'
        />
        <path
          d='M18.1862 48.4334C18.6934 48.4334 19.1045 48.0223 19.1045 47.5152C19.1045 47.008 18.6934 46.5969 18.1862 46.5969C17.6791 46.5969 17.2679 47.008 17.2679 47.5152C17.2679 48.0223 17.6791 48.4334 18.1862 48.4334Z'
          fill='#386895'
        />
        <path
          d='M26.679 48.4334C27.1862 48.4334 27.5973 48.0223 27.5973 47.5152C27.5973 47.008 27.1862 46.5969 26.679 46.5969C26.1719 46.5969 25.7607 47.008 25.7607 47.5152C25.7607 48.0223 26.1719 48.4334 26.679 48.4334Z'
          fill='#386895'
        />
        <path
          d='M19.5872 52.9861C20.2325 53.7794 21.2158 54.287 22.3183 54.287C23.4208 54.287 24.4039 53.7795 25.0493 52.9861H19.5872Z'
          fill='#386895'
        />
        <path
          d='M54.6415 64.1669C60.2201 64.1669 64.7424 59.6445 64.7424 54.0659C64.7424 48.4873 60.2201 43.965 54.6415 43.965C49.0629 43.965 44.5405 48.4873 44.5405 54.0659C44.5405 59.6445 49.0629 64.1669 54.6415 64.1669Z'
          fill='#FFEDB5'
        />
        <path
          d='M50.5093 52.4577C51.0165 52.4577 51.4276 52.0465 51.4276 51.5394C51.4276 51.0322 51.0165 50.6211 50.5093 50.6211C50.0022 50.6211 49.5911 51.0322 49.5911 51.5394C49.5911 52.0465 50.0022 52.4577 50.5093 52.4577Z'
          fill='#386895'
        />
        <path
          d='M59.0023 52.4577C59.5094 52.4577 59.9205 52.0465 59.9205 51.5394C59.9205 51.0322 59.5094 50.6211 59.0023 50.6211C58.4951 50.6211 58.084 51.0322 58.084 51.5394C58.084 52.0465 58.4951 52.4577 59.0023 52.4577Z'
          fill='#386895'
        />
        <path
          d='M58.1613 57.0494C58.1613 58.9933 56.5852 60.5694 54.6413 60.5694C52.6974 60.5694 51.1213 58.9933 51.1213 57.0494H58.1613Z'
          fill='#386895'
        />
        <path d='M64.7426 27.068H44.5405V28.5373H64.7426V27.068Z' fill='#366695' />
        <path d='M64.7426 31.1084H44.5405V32.5778H64.7426V31.1084Z' fill='#366695' />
      </g>
      <defs>
        <clipPath id='clip0_3_15196'>
          <rect width='80' height='80' fill='white' transform='translate(0.5)' />
        </clipPath>
      </defs>
    </svg>
  );
};

const FindIcon = () => {
  return (
    <svg width='81' height='80' viewBox='0 0 81 80' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_3_15146)'>
        <path
          d='M40.5 80C62.5914 80 80.5 62.0914 80.5 40C80.5 17.9086 62.5914 0 40.5 0C18.4086 0 0.5 17.9086 0.5 40C0.5 62.0914 18.4086 80 40.5 80Z'
          fill='#FFCD4B'
        />
        <path
          d='M80.3883 43.0119L60.1494 22.7731L20.8508 67.97L31.9691 79.0883C34.718 79.6855 37.5722 80 40.5 80C61.5782 80 78.8485 63.6966 80.3883 43.0119Z'
          fill='#FFA300'
        />
        <path d='M49.4063 12.03L60.1493 22.773V67.97H20.8508V12.03H49.4063Z' fill='white' />
        <path d='M60.1492 22.7731L49.4063 12.03H40.5189V67.97H60.1492V22.7731Z' fill='#E9EDF5' />
        <path d='M49.4062 22.773V12.03L60.1494 22.773H49.4062Z' fill='#BEC3D2' />
        <path d='M24.8402 24.1544H29.9744V28.8419H24.8402V24.1544Z' fill='#DCE1EB' />
        <path d='M24.8402 33.2631H29.9744V37.9506H24.8402V33.2631Z' fill='#DCE1EB' />
        <path d='M24.8402 42.3719H29.9744V47.0594H24.8402V42.3719Z' fill='#DCE1EB' />
        <path d='M24.8402 51.4805H29.9744V56.168H24.8402V51.4805Z' fill='#DCE1EB' />
        <path d='M33.9014 51.4805H39.0356V56.168H33.9014V51.4805Z' fill='#DCE1EB' />
        <path d='M33.9014 24.1544H39.0356V28.8419H33.9014V24.1544Z' fill='#DCE1EB' />
        <path
          d='M51.4089 50.4586L58.0371 43.8305L72.079 57.8724L65.4508 64.5005L51.4089 50.4586Z'
          fill='#FF6C52'
        />
        <path
          d='M54.8378 47.03L58.0372 43.8306L72.0791 57.8725L68.8797 61.0719L54.8378 47.03Z'
          fill='#FF432E'
        />
        <path
          d='M48.4494 54.1334C55.7814 54.1334 61.7252 48.1897 61.7252 40.8577C61.7252 33.5257 55.7814 27.5819 48.4494 27.5819C41.1174 27.5819 35.1736 33.5257 35.1736 40.8577C35.1736 48.1897 41.1174 54.1334 48.4494 54.1334Z'
          fill='#1DD882'
        />
        <path
          d='M57.8368 31.4702C52.6907 26.3241 44.3727 26.2887 39.1796 31.3583L57.9486 50.1273C63.0183 44.9342 62.9828 36.6163 57.8368 31.4702Z'
          fill='#2CC47F'
        />
        <path
          d='M48.4494 56.4772C44.2772 56.4772 40.3547 54.8525 37.4045 51.9023C31.3144 45.8122 31.3144 35.903 37.4045 29.813C40.3547 26.8628 44.277 25.2381 48.4494 25.2381C52.6214 25.2381 56.5439 26.8628 59.4939 29.813C62.4442 32.7631 64.0689 36.6855 64.0689 40.8577C64.0689 45.0299 62.4442 48.9522 59.4939 51.9023C56.5439 54.8525 52.6214 56.4772 48.4494 56.4772ZM40.7191 48.5877C42.7839 50.6525 45.5292 51.7897 48.4494 51.7897C51.3695 51.7897 54.1147 50.6527 56.1795 48.5878C58.2444 46.523 59.3816 43.7777 59.3816 40.8577C59.3816 37.9375 58.2444 35.1923 56.1795 33.1275C54.1147 31.0627 51.3695 29.9255 48.4494 29.9255C45.5292 29.9255 42.7839 31.0627 40.7191 33.1275C36.4567 37.3898 36.4567 44.3253 40.7191 48.5877Z'
          fill='#555A66'
        />
        <path
          d='M48.4493 29.9255C51.3693 29.9255 54.1147 31.0625 56.1795 33.1275C58.2443 35.1922 59.3815 37.9375 59.3815 40.8577C59.3815 43.7234 58.2839 46.4192 56.2914 48.4703L59.6073 51.7863C62.4853 48.8495 64.069 44.9756 64.069 40.8577C64.069 36.6855 62.4443 32.7631 59.494 29.813C56.5439 26.8628 52.6215 25.2381 48.4493 25.2381C44.3314 25.2381 40.4573 26.8219 37.5208 29.6997L40.8367 33.0156C42.8878 31.0231 45.5836 29.9255 48.4493 29.9255Z'
          fill='#333940'
        />
        <path
          d='M46.23 48.1059L40.2725 42.1486L43.587 38.8341L46.23 41.477L53.3115 34.3953L56.6261 37.7098L46.23 48.1059Z'
          fill='white'
        />
        <path
          d='M47.755 39.9441L53.3018 34.3974L56.6158 37.7115L51.0691 43.2582L47.755 39.9441Z'
          fill='#E9EDF5'
        />
      </g>
      <defs>
        <clipPath id='clip0_3_15146'>
          <rect width='80' height='80' fill='white' transform='translate(0.5)' />
        </clipPath>
      </defs>
    </svg>
  );
};

const GrowYourBusinessIcon = () => {
  return (
    <svg width='81' height='80' viewBox='0 0 81 80' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_38_15971)'>
        <path
          d='M40.5 80C62.5914 80 80.5 62.0914 80.5 40C80.5 17.9086 62.5914 0 40.5 0C18.4086 0 0.5 17.9086 0.5 40C0.5 62.0914 18.4086 80 40.5 80Z'
          fill='#0E14A3'
        />
        <path
          d='M18.6488 64.7189L33.278 79.3481C35.6207 79.7753 38.0341 80 40.5001 80C62.5915 80 80.5001 62.0914 80.5001 40C80.5001 38.9608 80.4602 37.9308 80.3824 36.9114L58.6408 15.1697L18.6488 64.7189Z'
          fill='#3339CC'
        />
        <path
          d='M39.4132 64.7189H18.6488V16.7064H39.4132L41.8846 41.1277L39.4132 64.7189Z'
          fill='#B2D7F3'
        />
        <path d='M39.4132 16.7064H57.1041V64.7189H39.4132V16.7064Z' fill='#95C7EE' />
        <path
          d='M39.4132 63.1822H20.1855V15.1697H39.4132L43.4213 39.5909L39.4132 63.1822Z'
          fill='white'
        />
        <path d='M39.4132 15.1697H58.6409V63.1822H39.4132V15.1697Z' fill='#EEEAE7' />
        <path
          d='M39.4132 24.1094H35.1794V21.7809H39.4132L43.3788 22.9653L39.4132 24.1094Z'
          fill='#525264'
        />
        <path d='M39.4132 21.7809H54.3348V24.1095H39.4132V21.7809Z' fill='#454553' />
        <path
          d='M39.4132 28.2566H35.1794V25.928H39.4132L43.3788 27.1124L39.4132 28.2566Z'
          fill='#525264'
        />
        <path d='M39.4132 25.928H51.2613V28.2566H39.4132V25.928Z' fill='#454553' />
        <path
          d='M39.4132 36.6303H35.1794V34.3019H39.4132L43.3788 35.4863L39.4132 36.6303Z'
          fill='#525264'
        />
        <path d='M39.4132 34.3019H54.3348V36.6305H39.4132V34.3019Z' fill='#454553' />
        <path
          d='M39.4132 40.7775H35.1794V38.4489H39.4132L43.3788 39.6333L39.4132 40.7775Z'
          fill='#525264'
        />
        <path d='M39.4132 38.4489H51.2613V40.7775H39.4132V38.4489Z' fill='#454553' />
        <path
          d='M27.396 29.1863C29.8301 29.1863 31.8033 27.213 31.8033 24.7789C31.8033 22.3448 29.8301 20.3716 27.396 20.3716C24.9619 20.3716 22.9886 22.3448 22.9886 24.7789C22.9886 27.213 24.9619 29.1863 27.396 29.1863Z'
          fill='#00DC80'
        />
        <path
          d='M27.5012 27.1105L24.5588 23.9722L26.2406 22.3955L27.2909 23.5161L30.8765 18.6628L32.7304 20.0327L27.5012 27.1105Z'
          fill='#525264'
        />
        <path
          d='M27.2646 41.4127C29.6988 41.4127 31.672 39.4394 31.672 37.0053C31.672 34.5712 29.6988 32.598 27.2646 32.598C24.8305 32.598 22.8573 34.5712 22.8573 37.0053C22.8573 39.4394 24.8305 41.4127 27.2646 41.4127Z'
          fill='#00DC80'
        />
        <path
          d='M27.3697 39.3369L24.4274 36.1984L26.1091 34.6219L27.1594 35.7425L30.745 30.8892L32.5989 32.2589L27.3697 39.3369Z'
          fill='#525264'
        />
        <path
          d='M39.4132 49.8806H35.1794V47.552H39.4132L43.3788 48.7364L39.4132 49.8806Z'
          fill='#525264'
        />
        <path d='M39.4132 47.552H54.3348V49.8806H39.4132V47.552Z' fill='#454553' />
        <path
          d='M39.4132 54.0277H35.1794V51.6991H39.4132L43.3788 52.8834L39.4132 54.0277Z'
          fill='#525264'
        />
        <path d='M39.4132 51.6991H46.9437V54.0277H39.4132V51.6991Z' fill='#454553' />
        <path
          d='M27.2646 48.1531C28.4239 48.1531 29.367 49.0963 29.367 50.2555C29.367 51.4147 28.4239 52.3578 27.2646 52.3578C26.1054 52.3578 25.1623 51.4147 25.1623 50.2555C25.1623 49.0963 26.1054 48.1531 27.2646 48.1531ZM27.2646 45.8481C24.8306 45.8481 22.8573 47.8214 22.8573 50.2555C22.8573 52.6895 24.8306 54.6628 27.2646 54.6628C29.6987 54.6628 31.672 52.6895 31.672 50.2555C31.672 47.8214 29.6989 45.8481 27.2646 45.8481Z'
          fill='#B2D7F3'
        />
        <path
          d='M54.6603 66.0901L52.0288 61.1991L46.7294 62.8617L51.2145 51.8438L59.1455 55.0722L54.6603 66.0901Z'
          fill='#FE6A16'
        />
        <path
          d='M62.3394 66.0901L64.9709 61.1991L70.2704 62.8617L65.7852 51.8438L57.8542 55.0722L62.3394 66.0901Z'
          fill='#F24500'
        />
        <path
          d='M70.5 47.5051C70.5 48.7416 69.2538 49.766 68.8915 50.8817C68.5161 52.038 68.9092 53.5968 68.2088 54.5593C67.5013 55.5314 65.8926 55.6358 64.9205 56.3433C63.958 57.0437 63.3654 58.5454 62.2091 58.9209C61.0934 59.2831 59.7364 58.4285 58.5 58.4285C57.2635 58.4285 55.9065 59.2831 54.7909 58.9209C53.6346 58.5455 53.042 57.0437 52.0795 56.3433C51.1074 55.6358 49.4987 55.5313 48.7912 54.5593C48.0908 53.5968 48.4839 52.0381 48.1085 50.8818C47.7462 49.7661 46.5 48.7417 46.5 47.5052C46.5 46.2688 47.7462 45.2444 48.1085 44.1287C48.4839 42.9723 48.0908 41.4136 48.7912 40.4511C49.4987 39.479 51.1074 39.3745 52.0795 38.6671C53.042 37.9666 53.6346 36.465 54.7909 36.0895C55.9066 35.7272 57.2636 36.5819 58.5 36.5819C59.7365 36.5819 61.0935 35.7272 62.2091 36.0895C63.3654 36.4649 63.958 37.9666 64.9205 38.6671C65.8926 39.3745 67.5013 39.479 68.2088 40.4511C68.9092 41.4136 68.5161 42.9723 68.8915 44.1286C69.2537 45.2443 70.5 46.2687 70.5 47.5051Z'
          fill='#F2AF00'
        />
        <path
          d='M68.8914 44.1286C68.5159 42.9723 68.909 41.4135 68.2086 40.4511C67.5012 39.479 65.8924 39.3745 64.9203 38.6671C63.9579 37.9666 63.3652 36.465 62.2089 36.0895C61.0932 35.7272 59.7363 36.5819 58.4999 36.5819V58.4285C59.7363 58.4285 61.0933 59.2831 62.209 58.9209C63.3653 58.5455 63.9579 57.0437 64.9203 56.3433C65.8924 55.6358 67.5012 55.5313 68.2086 54.5593C68.909 53.5968 68.5159 52.038 68.8914 50.8817C69.2536 49.766 70.4998 48.7416 70.4998 47.5051C70.4998 46.2687 69.2536 45.2443 68.8914 44.1286Z'
          fill='#F2AF00'
        />
        <path
          d='M58.4999 56.1807C63.2912 56.1807 67.1753 52.2966 67.1753 47.5053C67.1753 42.714 63.2912 38.8299 58.4999 38.8299C53.7086 38.8299 49.8245 42.714 49.8245 47.5053C49.8245 52.2966 53.7086 56.1807 58.4999 56.1807Z'
          fill='#FCD015'
        />
        <path
          d='M58.4999 38.8299V56.1807C63.2912 56.1807 67.1753 52.2966 67.1753 47.5053C67.1753 42.714 63.2912 38.8299 58.4999 38.8299Z'
          fill='#FDBA12'
        />
        <path
          d='M58.4998 40.6842L60.516 44.7695L65.0244 45.4246L61.7621 48.6046L62.5322 53.0947L58.4998 50.9747L54.4674 53.0947L55.2376 48.6046L51.9752 45.4246L56.4836 44.7695L58.4998 40.6842Z'
          fill='#FFA300'
        />
        <path
          d='M65.0245 45.4246L60.5161 44.7695L58.4999 40.6842V50.9747L62.5323 53.0947L61.7622 48.6046L65.0245 45.4246Z'
          fill='#FE8205'
        />
      </g>
      <defs>
        <clipPath id='clip0_38_15971'>
          <rect width='80' height='80' fill='white' transform='translate(0.5)' />
        </clipPath>
      </defs>
    </svg>
  );
};

const MakeAnImpactIcon = () => {
  return (
    <svg width='81' height='80' viewBox='0 0 81 80' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M40.5 80C62.5914 80 80.5 62.0914 80.5 40C80.5 17.9086 62.5914 0 40.5 0C18.4086 0 0.5 17.9086 0.5 40C0.5 62.0914 18.4086 80 40.5 80Z'
        fill='#0E14A3'
      />
      <path
        d='M18.6487 64.7189L33.278 79.3481C35.6206 79.7753 38.0341 80 40.5 80C62.5914 80 80.5 62.0914 80.5 40C80.5 38.9608 80.4601 37.9308 80.3823 36.9114L58.6408 15.1697L18.6487 64.7189Z'
        fill='#3339CC'
      />
      <path
        d='M39.4131 64.7189H18.6487V16.7064H39.4131L41.8845 41.1277L39.4131 64.7189Z'
        fill='#B2D7F3'
      />
      <path d='M39.4131 16.7064H57.104V64.7189H39.4131V16.7064Z' fill='#95C7EE' />
      <path
        d='M39.4131 63.1822H20.1855V15.1697H39.4131L43.4213 39.5909L39.4131 63.1822Z'
        fill='white'
      />
      <path d='M39.4131 15.1697H58.6408V63.1822H39.4131V15.1697Z' fill='#EEEAE7' />
      <path
        d='M39.4131 24.1094H35.1794V21.7809H39.4131L43.3788 22.9653L39.4131 24.1094Z'
        fill='#525264'
      />
      <path d='M39.4131 21.7809H54.3347V24.1095H39.4131V21.7809Z' fill='#454553' />
      <path
        d='M39.4131 28.2566H35.1794V25.928H39.4131L43.3788 27.1124L39.4131 28.2566Z'
        fill='#525264'
      />
      <path d='M39.4131 25.928H51.2613V28.2566H39.4131V25.928Z' fill='#454553' />
      <path
        d='M39.4131 36.6303H35.1794V34.3019H39.4131L43.3788 35.4863L39.4131 36.6303Z'
        fill='#525264'
      />
      <path d='M39.4131 34.3019H54.3347V36.6305H39.4131V34.3019Z' fill='#454553' />
      <path
        d='M39.4131 40.7775H35.1794V38.4489H39.4131L43.3788 39.6333L39.4131 40.7775Z'
        fill='#525264'
      />
      <path d='M39.4131 38.4489H51.2613V40.7775H39.4131V38.4489Z' fill='#454553' />
      <path
        d='M27.3959 29.1863C29.83 29.1863 31.8033 27.213 31.8033 24.7789C31.8033 22.3448 29.83 20.3716 27.3959 20.3716C24.9618 20.3716 22.9886 22.3448 22.9886 24.7789C22.9886 27.213 24.9618 29.1863 27.3959 29.1863Z'
        fill='#00DC80'
      />
      <path
        d='M27.5011 27.1105L24.5588 23.9722L26.2405 22.3955L27.2908 23.5161L30.8764 18.6628L32.7303 20.0327L27.5011 27.1105Z'
        fill='#525264'
      />
      <path
        d='M27.2645 41.4127C29.6986 41.4127 31.6719 39.4394 31.6719 37.0053C31.6719 34.5712 29.6986 32.598 27.2645 32.598C24.8304 32.598 22.8572 34.5712 22.8572 37.0053C22.8572 39.4394 24.8304 41.4127 27.2645 41.4127Z'
        fill='#00DC80'
      />
      <path
        d='M27.3697 39.3369L24.4274 36.1984L26.1091 34.6219L27.1594 35.7425L30.745 30.8892L32.5989 32.2589L27.3697 39.3369Z'
        fill='#525264'
      />
      <path
        d='M39.4131 49.8806H35.1794V47.552H39.4131L43.3788 48.7364L39.4131 49.8806Z'
        fill='#525264'
      />
      <path d='M39.4131 47.552H54.3347V49.8806H39.4131V47.552Z' fill='#454553' />
      <path
        d='M39.4131 54.0277H35.1794V51.6991H39.4131L43.3788 52.8834L39.4131 54.0277Z'
        fill='#525264'
      />
      <path d='M39.4131 51.6991H46.9436V54.0277H39.4131V51.6991Z' fill='#454553' />
      <path
        d='M27.2645 48.1531C28.4237 48.1531 29.3669 49.0963 29.3669 50.2555C29.3669 51.4147 28.4237 52.3578 27.2645 52.3578C26.1053 52.3578 25.1622 51.4147 25.1622 50.2555C25.1622 49.0963 26.1053 48.1531 27.2645 48.1531ZM27.2645 45.8481C24.8305 45.8481 22.8572 47.8214 22.8572 50.2555C22.8572 52.6895 24.8305 54.6628 27.2645 54.6628C29.6986 54.6628 31.6719 52.6895 31.6719 50.2555C31.6719 47.8214 29.6987 45.8481 27.2645 45.8481Z'
        fill='#B2D7F3'
      />
    </svg>
  );
};

const MatchIcon = () => {
  return (
    <svg width='81' height='80' viewBox='0 0 81 80' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M40.5 80C62.5914 80 80.5 62.0914 80.5 40C80.5 17.9086 62.5914 0 40.5 0C18.4086 0 0.5 17.9086 0.5 40C0.5 62.0914 18.4086 80 40.5 80Z'
        fill='#FFCD4B'
      />
      <path
        d='M26.4615 75.0889C29.5878 76.2606 32.9003 79.4305 36.3422 79.7859C37.7078 79.9281 39.0953 80 40.5 80C41.9047 80 43.2922 79.9281 44.6578 79.7859C47.9411 79.4467 51.1065 76.3326 54.105 75.2484C56.1481 74.5097 58.1136 75.9873 59.9859 74.9406C72.225 68.1 80.5 55.0156 80.5 40C80.5 39.3712 80.4836 38.7464 80.4548 38.1248C70.7501 28.4881 61.082 18.8928 61.082 18.8928L21.014 74.9406C22.7536 75.9131 24.5737 74.3812 26.4615 75.0889Z'
        fill='#FFA300'
      />
      <path
        d='M33.1385 41.1403L15.5974 28.0028L12.652 34.9313L24.2023 66.0788C24.2023 66.0788 29.3703 73.6905 33.3826 79.368C35.6923 79.783 38.0707 80 40.4999 80C62.5914 80 80.4999 62.0914 80.4999 40C80.4999 36.9292 80.1528 33.9397 79.4976 31.0673L56.6015 8.1711L33.1385 41.1403Z'
        fill='#FFA300'
      />
      <path
        d='M23.8097 40.4542L30.2641 50.7206C30.6841 51.3887 30.9489 52.1489 30.9908 52.937C30.9911 52.9419 30.9913 52.9467 30.9916 52.9517C31.0975 55.0309 31.3547 58.3094 31.9295 59.2403L31.5486 60.3705L28.1211 62.5253L17.1208 45.0283C15.8849 43.0623 16.4766 40.4666 18.4425 39.2306C20.2625 38.0864 22.6655 38.6342 23.8097 40.4542Z'
        fill='#FCC78D'
      />
      <path
        d='M36.3422 79.7859C30.8219 79.2156 25.6344 77.5234 21.0141 74.9406L20.6953 63.6734L10.65 47.6969C9.10002 45.2312 8.39377 42.3266 8.63596 39.4234L9.33752 31.0312C9.52346 28.8 11.5047 27.0734 13.7313 27.3031C15.8906 27.5234 17.4813 29.4344 17.3 31.6062L17.4703 40.9281L26.2906 55.2437C26.9703 56.3484 28.15 56.9562 29.3578 56.9562C30.0125 56.9562 30.675 56.7781 31.2703 56.4031L36.3422 79.7859Z'
        fill='#FFDBA9'
      />
      <path
        d='M57.1904 40.4542L50.736 50.7206C50.316 51.3887 50.0512 52.1489 50.0093 52.937C50.009 52.9419 50.0088 52.9467 50.0085 52.9517C49.9026 55.0309 49.6454 58.3094 49.0706 59.2403L49.4515 60.3705L52.879 62.5253L63.8793 45.0283C65.1152 43.0623 64.5235 40.4666 62.5576 39.2306C60.7376 38.0864 58.3346 38.6342 57.1904 40.4542Z'
        fill='#492B25'
      />
      <path
        d='M70.35 47.6969L60.3047 63.6734L59.986 74.9406C55.3657 77.5234 50.1781 79.2156 44.6578 79.7859L49.7297 56.4031C50.325 56.7781 50.9875 56.9562 51.6422 56.9562C52.85 56.9562 54.0297 56.3484 54.7094 55.2437L63.5297 40.9281L63.7 31.6062C63.5188 29.4344 65.1094 27.5234 67.2688 27.3031C69.4953 27.0734 71.4766 28.8 71.6625 31.0312L72.3641 39.4234C72.6063 42.3266 71.9 45.2312 70.35 47.6969Z'
        fill='#68463E'
      />
      <path
        d='M26.7423 10.515V25.9667C26.7423 31.602 28.9164 39.3709 40.5 43.0705C52.0836 39.3709 54.2576 31.602 54.2576 25.9667C54.2576 20.3314 54.2576 10.515 54.2576 10.515H26.7423Z'
        fill='#1DD882'
      />
      <path
        d='M54.2578 10.5156V25.9672C54.2578 31.6016 52.0844 39.3703 40.5 43.0703V10.5156H54.2578Z'
        fill='#2CC47F'
      />
      <path
        d='M40.5 45.5306L39.7869 45.303C34.0725 43.4778 29.8725 40.5191 27.3036 36.5086C25.3759 33.4991 24.3984 29.9522 24.3984 25.9666V8.1711H56.6016V25.9666C56.6016 29.9522 55.6241 33.4991 53.6964 36.5086C51.1275 40.5191 46.9275 43.478 41.2131 45.303L40.5 45.5306ZM29.0859 12.8586V25.9666C29.0859 33.0456 32.9248 37.9656 40.5 40.5998C48.075 37.9656 51.9141 33.0455 51.9141 25.9666V12.8586H29.0859Z'
        fill='white'
      />
      <path
        d='M40.5 8.17125V12.8587H51.9141V25.9666C51.9141 33.0447 48.075 37.965 40.5 40.5994V45.5306L41.2125 45.3025C46.9281 43.4775 51.1281 40.5181 53.6969 36.5072C55.6234 33.4978 56.6016 29.9509 56.6016 25.9666V8.17125H40.5Z'
        fill='#E0E0E0'
      />
      <path
        d='M43.3884 20.1555L39.7611 24.7297L36.7959 22.4077L33.7842 26.2539L40.5721 31.5694L47.1187 23.313L47.2159 23.1906L43.3884 20.1555Z'
        fill='white'
      />
      <path
        d='M47.2156 23.1906L47.1187 23.3125L40.5719 31.5687L40.5 31.5125V23.7984L43.3891 20.1562L47.2156 23.1906Z'
        fill='#E0E0E0'
      />
    </svg>
  );
};

const RequestSupportIcon = () => {
  return (
    <svg width='81' height='80' viewBox='0 0 81 80' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_38_15854)'>
        <path
          d='M80.5 40C80.5 62.0917 62.5917 80 40.5 80C18.4083 80 0.5 62.0917 0.5 40C0.5 17.9083 18.4083 0 40.5 0C62.5917 0 80.5 17.9083 80.5 40Z'
          fill='#0E14A3'
        />
        <path
          d='M80.4158 37.4365L61.8367 18.8574L58.3796 22.3145L59.7877 23.7219L58.8386 24.671L63.2917 29.1241L61.7158 30.7007L50.4469 19.4318L35.8857 33.9935L23.9235 22.0306L23.0323 22.9218L19.5057 19.3951L17.4031 21.4978L36.1769 40.3125L35.6904 40.7996L23.0433 28.1116L20.3871 30.7684L18.7996 29.1809L16.6969 31.2836L22.5593 37.1454L19.1633 40.5414L41.2812 62.5L40.4908 69.5642L49.8304 78.9032C67.4208 74.6997 80.5 58.8782 80.5 40C80.5 39.1388 80.4695 38.2843 80.4158 37.4365Z'
          fill='#3339CC'
        />
        <path
          d='M46.8477 45.5682V56.7822L40.8174 59.9561L40.5 59.7974L34.1523 56.7822V45.5682H46.8477Z'
          fill='#FF641A'
        />
        <path
          d='M46.8477 45.5682V56.7822L40.8174 59.9561L40.5 59.7974V45.5682H46.8477Z'
          fill='#F03800'
        />
        <path
          d='M54.7822 29.6991C54.7822 33.5712 53.2588 37.1893 50.4658 39.9188C48.8154 41.5057 47.6728 43.6005 47.165 45.9174H33.8349C33.2954 43.6005 32.1205 41.474 30.4072 39.7919C27.1382 36.5228 25.6782 32.0477 26.3764 27.4457C27.3286 21.2885 32.5337 16.2738 38.7544 15.5121C39.3257 15.4486 39.9287 15.4169 40.5 15.4169C43.9912 15.4169 47.3872 16.6858 49.9897 19.0033C53.0366 21.7328 54.7822 25.6042 54.7822 29.6991Z'
          fill='#FFDA2D'
        />
        <path
          d='M54.7822 29.6991C54.7822 33.5712 53.2588 37.1893 50.4658 39.9188C48.8154 41.5057 47.6729 43.6005 47.165 45.9174H40.5V15.4169C43.9912 15.4169 47.3872 16.6858 49.9897 19.0033C53.0366 21.7328 54.7822 25.6042 54.7822 29.6991Z'
          fill='#FDBF00'
        />
        <path
          d='M47.9585 31.7615L45.7368 33.9832L44.1182 32.3651L42.0869 36.4276V45.5682H38.9131V36.4276L36.8818 32.3651L35.2632 33.9832L33.0415 31.7615L37.7705 27.0331L40.5 32.4921L43.2295 27.0331L47.9585 31.7615Z'
          fill='#FDBF00'
        />
        <path
          d='M42.0869 45.5682H40.5V32.4921L43.2295 27.0331L47.9585 31.7615L45.7368 33.9832L44.1182 32.3651L42.0869 36.4276V45.5682Z'
          fill='#FF9100'
        />
        <path d='M16.6963 28.1122H23.0439V31.286H16.6963V28.1122Z' fill='#FFDA2D' />
        <path
          d='M19.1639 18.858L23.9253 22.0319L22.165 24.6729L17.4037 21.499L19.1639 18.858Z'
          fill='#FFDA2D'
        />
        <path
          d='M22.162 34.7272L23.9222 37.3682L19.1615 40.542L17.4006 37.901L22.162 34.7272Z'
          fill='#FFDA2D'
        />
        <path d='M57.9561 28.1122H64.3037V31.286H57.9561V28.1122Z' fill='#FDBF00' />
        <path
          d='M61.8354 18.8599L63.5963 21.5009L58.835 24.6747L57.0747 22.0337L61.8354 18.8599Z'
          fill='#FDBF00'
        />
        <path
          d='M58.8392 34.7278L63.6 37.9016L61.8397 40.5426L57.079 37.3688L58.8392 34.7278Z'
          fill='#FDBF00'
        />
        <path d='M46.8477 56.7822L40.5 69.5831L34.1523 56.7822H46.8477Z' fill='#FFCEBF' />
        <path d='M40.5 56.7822H46.8477L40.5 69.5831V56.7822Z' fill='#FFB99C' />
        <path d='M30.9785 43.9813H50.0215V47.1552H30.9785V43.9813Z' fill='#D8D8FC' />
        <path d='M40.5 43.9813H50.0215V47.1552H40.5V43.9813Z' fill='#A3A3D1' />
      </g>
      <defs>
        <clipPath id='clip0_38_15854'>
          <rect width='80' height='80' fill='white' transform='translate(0.5)' />
        </clipPath>
      </defs>
    </svg>
  );
};

const Step = ({
  svg,
  title,
  description,
}: {
  svg: ReactElement;
  title: string;
  description: string;
}) => {
  return (
    <div className='flex flex-col items-center gap-[0.5] text-center'>
      {svg}
      <h2 className='mt-4 text-base font-semibold text-gray-500 whitespace-nowrap'>{title}</h2>
      <p className='text-xs text-gray-400'>{description}</p>
    </div>
  );
};

const StepsDiagram = ({ children }: { children: ReactNode }) => {
  return (
    <div>
      {/* Gray border that visualizes a line between the SVG icons. Is placed behind the SVGs via negative margin
       * on the SVG container below */}
      <div className='hidden lg:block border-t-2 mt-10 z-0 mx-16' />
      <div className='relative z-10 flex flex-col lg:flex-row gap-[16px] lg:mt-[-41px]'>
        {children}
      </div>
    </div>
  );
};

/** Displays a static set of next steps based on the users role (experteer or representative) */
const NextStepsSegment = () => {
  const { isSuccess, data: user } = Users.useGetCurrentUser();

  const nextStepUrl =
    user?.accountType === 'organization' ? '/platform/create-project' : '/platform/project-search';
  const nextStepText =
    user?.accountType === 'organization' ? 'Submit support request' : 'Find a project';

  if (!isSuccess) {
    return null;
  }

  return (
    <div className='flex flex-col justify-center items-center bg-white px-4 py-6 border border-solid border-gray-200 rounded-xl'>
      <h2 className='relative text-2xl font-semibold mb-6 md:mb-12'>How it works</h2>
      {user?.accountType === 'organization' && (
        <StepsDiagram>
          <Step
            svg={<RequestSupportIcon />}
            title='Request Support'
            description='Provide details about the business challenge you want support with'
          />
          <Step
            svg={<FindIcon />}
            title='Find an Experteer'
            description="Introduce yourself to 3-5 Experteers, see if they're the right fit over a call"
          />
          <Step
            svg={<MatchIcon />}
            title='Match'
            description='If you want to work together, let the Experteer know during your call'
          />
          <Step
            svg={<GrowYourBusinessIcon />}
            title='Grow your business'
            description='Work with your Experteer, and keep us updated so we can provide support'
          />
        </StepsDiagram>
      )}
      {user?.accountType === 'experteer' && (
        <StepsDiagram>
          <Step
            svg={<FindIcon />}
            title='Find a project'
            description='Find 3-5 projects that resonate with you and introduce yourself'
          />
          <Step
            svg={<ConnectIcon />}
            title='Connect'
            description="If they accept your introduction, have a call to see if it's a good match"
          />
          <Step
            svg={<MatchIcon />}
            title='Match'
            description='If after your call you want to work together, match and get started'
          />
          <Step
            svg={<MakeAnImpactIcon />}
            title='Make an impact'
            description='Work on your project, and keep us updated so we can provide support'
          />
        </StepsDiagram>
      )}
      <div className='mt-9 sm:mt-12 w-64'>
        <Button variant='primary' size='xl' href={nextStepUrl}>
          {nextStepText}
        </Button>
      </div>
    </div>
  );
};

export default NextStepsSegment;
